import { isUndefined } from '../../TypeHelpers';
import sum from './sum';
export default function average(array, selector) {
    if (array.length > 0) {
        if (!isUndefined(selector)) {
            return sum(array, selector) / array.length;
        }
        else {
            return sum(array) / array.length;
        }
    }
    return 0;
}
